var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamEditorButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FE815F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8652 10.7911C16.0605 10.5958 16.377 10.5958 16.5723 10.7911L21.2089 15.4277C21.4042 15.623 21.4042 15.9395 21.2089 16.1348L14.4902 22.8536C14.3964 22.9473 14.2693 23 14.1366 23H9.5C9.22386 23 9 22.7761 9 22.5V17.8634C9 17.7307 9.05268 17.6036 9.14645 17.5098L15.8652 10.7911ZM16.5723 13.5098C16.377 13.3145 16.0605 13.3145 15.8652 13.5098L11.0214 18.3536C10.9277 18.4473 10.875 18.5745 10.875 18.7071V20.625C10.875 20.9011 11.0989 21.125 11.375 21.125H13.2929C13.4255 21.125 13.5527 21.0723 13.6464 20.9786L18.4902 16.1348C18.6855 15.9395 18.6855 15.623 18.4902 15.4277L16.5723 13.5098ZM18.3936 8.33661C18.5916 8.14964 18.9027 8.15546 19.0936 8.34971L23.6527 12.9902C23.845 13.186 23.8436 13.5001 23.6496 13.6942L22.7598 14.5839C22.5645 14.7792 22.248 14.7792 22.0527 14.5839L17.4263 9.95755C17.2271 9.75833 17.2317 9.43394 17.4365 9.24049L18.3936 8.33661Z",
    fill: "var(--bg-white-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamEditorButton);
export default __webpack_public_path__ + "static/media/streamEditorButton.d94b40a55e5d9acfa03e3713461038a9.svg";
export { ForwardRef as ReactComponent };